import { StoreWorkingTime } from './StoreWorkingTime';
import { DayOfWeek } from '../../enums/DayOfWeek';

/**
 * This class contains default store opening and closing times for each day of the week.
 */
export class StoreDefaultWorkingTime {
  startDate: string;
  weeklyTimes: Map<DayOfWeek, StoreWorkingTime>;

  constructor(startDate: string, weeklyTimes: Map<DayOfWeek, StoreWorkingTime>) {
    this.startDate = startDate;
    this.weeklyTimes = weeklyTimes;
  }
}
